// src/components/landing/Footer.tsx
// UPDATED: FAQ link naar /faq pagina + suppressHydrationWarning voor jaar

import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Column 1: Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">W</span>
              </div>
              <span className="text-xl font-bold text-white">
                WFT Study Buddy
              </span>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              De slimste manier om je voor te bereiden op je WFT examen. Met AI-technologie en gepersonaliseerde training.
            </p>
          </div>

          {/* Column 2: Product */}
          <div>
            <h3 className="text-white font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#features" className="hover:text-white transition">Features</a>
              </li>
              <li>
                <a href="#pricing" className="hover:text-white transition">Prijzen</a>
              </li>
              <li>
                <a href="#how-it-works" className="hover:text-white transition">Hoe werkt het?</a>
              </li>
              <li>
                <Link to="/faq" className="hover:text-white transition">Veelgestelde vragen</Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-white transition">Start Gratis</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: WFT Examens */}
          <div>
            <h3 className="text-white font-semibold mb-4">WFT Examens</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/wft-basis" className="hover:text-white transition">WFT Basis</Link>
              </li>
              <li>
                <Link to="/wft-schade-particulier" className="hover:text-white transition">WFT Schade Particulier</Link>
              </li>
              <li>
                <Link to="/wft-schade-zakelijk" className="hover:text-white transition">WFT Schade Zakelijk</Link>
              </li>
              <li>
                <Link to="/wft-hypotheken" className="hover:text-white transition">WFT Hypotheken</Link>
              </li>
              <li>
                <Link to="/wft-vermogen" className="hover:text-white transition">WFT Vermogen</Link>
              </li>
              <li>
                <Link to="/wft-inkomen" className="hover:text-white transition">WFT Inkomen</Link>
              </li>
              <li>
                <Link to="/wft-examens" className="hover:text-white transition font-medium">Alle examens →</Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Bedrijf */}
          <div>
            <h3 className="text-white font-semibold mb-4">Bedrijf</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/informatie" className="hover:text-white transition">Kennisbank</Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-white transition">FAQ</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition">Contact</Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white transition">Algemene Voorwaarden</Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white transition">Privacybeleid</Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="hover:text-white transition">Cookiebeleid</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              © <span suppressHydrationWarning>{new Date().getFullYear()}</span> WFT Study Buddy. Alle rechten voorbehouden.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <Link to="/terms" className="text-sm text-gray-400 hover:text-white transition">
                Voorwaarden
              </Link>
              <Link to="/privacy" className="text-sm text-gray-400 hover:text-white transition">
                Privacy
              </Link>
              <Link to="/cookie-policy" className="text-sm text-gray-400 hover:text-white transition">
                Cookies
              </Link>
              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-400">Made with</span>
                <span className="text-red-500">❤️</span>
                <span className="text-sm text-gray-400">in Nederland</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;